import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  cardWrapper: {
    margin: '24px 40px',
    padding: '20px'
  },
  formCardWrapper: {
    margin: '0px 40px',
  },
  paper: {
    padding: '30px 20px 80px'
  },
  headerWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '40px 40px 24px',
    flexWrap: 'wrap'
  },
  title: {
    color: '#335977',
    fontWeight: 'bold',
    fontSize: '38px'
  },
  formTitle: {
    marginBottom: '10px',
    maxWidth: '800px',
    fontSize: '16px',
    color: '#5F6062'
  },
  textInput: {
    width: '40%',
    minWidth: '180px',
    marginBottom: '30px'
  },
  formContainer: {
    display: 'flex',
    marginBottom: '50px',
    flexWrap: 'wrap'
  },
  formPaper: {
    width: '250px',
    margin: '20px 0',
    minHeight: '200px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    border: '1px solid #70707033',
    opacity: 1
  },
  arrowContainer: {
    display: 'flex',
    alignItems: 'center',
    margin: '0 20px'
  },
  mb20: {
    marginBottom: '20px'
  },
  mb10: {
    marginBottom: '10px'
  },
  linkStyle: {
    textDecoration: 'none',
    color: '#026AE3',
  },
  hr: {
    borderColor: '#70707033',
  },
  floatR: {
    float: 'right',
    width: '150px'
  },
  uploadInput: {
    display: 'none',
  },
  fileName: {
    margin: '5px 0 0',
    fontSize: '12px'
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-around'
  },
  deleteButton: {
    margin: '10px 10px 0',
    height: '40px'
  },
  editIcon: {
    fontSize: '18px',
    verticalAlign: 'middle',
    color: '#026AE3',
    margin: '10px',
    cursor: 'pointer',
  },
  disabledIcon: {
    color: '#00000042',
    cursor: 'not-allowed'
  },
  TextTransform: {
    textTransform: 'uppercase'
  },
  deleteModalText: {
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#565657'
  }
}))

export { useStyles }